this.Shopify=this.Shopify||{},this.Shopify.theme=this.Shopify.theme||{},this.Shopify.theme.cart=function(t){"use strict";function u(){return JSON.parse(JSON.stringify({credentials:"same-origin",headers:{"X-Requested-With":"XMLHttpRequest","Content-Type":"application/json;"}}))}function a(t,e){return fetch(t,e).then(function(t){if(!t.ok)throw t;return t.json()})}function e(){return a("/cart.js",u())}function r(t,e){var r=u();return e=e||{},r.method="POST",r.body=JSON.stringify({line:t,quantity:e.quantity,properties:e.properties}),a("/cart/change.js",r)}function n(t){var e=u();return e.method="POST",e.body=JSON.stringify(t),a("/cart/update.js",e)}function i(t){if("string"!=typeof t||2!==t.split(":").length)throw new TypeError("Theme Cart: Provided key value is not a string with the format xxx:xxx")}function o(t){if("object"!=typeof t)throw new TypeError("Theme Cart: Options must be an object");if(void 0===t.quantity&&void 0===t.properties)throw new Error("Theme Cart: You muse define a value for quantity or properties");void 0!==t.quantity&&function(t){if("number"!=typeof t)throw new TypeError("Theme Cart: An object which specifies a quantity or properties value is required")}(t.quantity),void 0!==t.properties&&function(t){if("object"!=typeof t)throw new TypeError("Theme Cart: Properties must be an object")}(t.properties)}function c(n){return i(n),e().then(function(t){var r=-1;return t.items.forEach(function(t,e){r=t.key===n?e+1:r}),-1===r?Promise.reject(new Error("Theme Cart: Unable to match line item with provided key")):r})}function f(){return e().then(function(t){return t.attributes})}function s(t){return n({attributes:t})}return t.getState=function(){return e()},t.getItemIndex=c,t.getItem=function(r){return i(r),e().then(function(t){var e=null;return t.items.forEach(function(t){e=t.key===r?t:e}),null===e?Promise.reject(new Error("Theme Cart: Unable to match line item with provided key")):e})},t.addItem=function(t,e){return e=e||{},function(t){if("number"!=typeof t)throw new TypeError("Theme Cart: Variant ID must be a number")}(t),r=t,n=e.quantity,i=e.properties,(o=u()).method="POST",o.body=JSON.stringify({id:r,quantity:n,properties:i}),a("/cart/add.js",o);var r,n,i,o},t.updateItem=function(t,e){return i(t),o(e),c(t).then(function(t){return r(t,e)})},t.removeItem=function(t){return i(t),c(t).then(function(t){return r(t,{quantity:0})})},t.clearItems=function(){return(t=u()).method="POST",a("/cart/clear.js",t);var t},t.getAttributes=f,t.updateAttributes=s,t.clearAttributes=function(){return f().then(function(t){for(var e in t)t[e]="";return s(t)})},t.getNote=function(){return e().then(function(t){return t.note})},t.updateNote=function(t){return n({note:t})},t.clearNote=function(){return n({note:""})},t.getShippingRates=function(){return a("/cart/shipping_rates.json",u())},t}({});
this.Shopify=this.Shopify||{},this.Shopify.theme=this.Shopify.theme||{},this.Shopify.theme.addresses=function(e){"use strict";var r="query countries($locale: SupportedLocale!) {  countries(locale: $locale) {    name    code    labels {      address1      address2      city      company      country      firstName      lastName      phone      postalCode      zone    }    formatting {      edit    }    zones {      name      code    }  }}",a="https://country-service.shopifycloud.com/graphql";function u(e){var n,t;return fetch(a,{method:"POST",headers:{"Content-Type":"application/json","Access-Control-Allow-Origin":"*"},body:JSON.stringify({query:r,operationName:"countries",variables:{locale:(n=e,t=n.replace(/-/,"_").toUpperCase(),-1!==i.indexOf(t)?t:-1!==i.indexOf(t.substring(0,2))?t.substring(0,2):o)}})}).then(function(e){return e.json()}).then(function(e){return e.data.countries})}var o="EN",i=["DA","DE","EN","ES","FR","IT","JA","NL","PT","PT_BR"];var h=/({\w+})/g,m="_",d={lastName:'[name="address[last_name]"]',firstName:'[name="address[first_name]"]',company:'[name="address[company]"]',address1:'[name="address[address1]"]',address2:'[name="address[address2]"]',country:'[name="address[country]"]',zone:'[name="address[province]"]',postalCode:'[name="address[zip]"]',city:'[name="address[city]"]',phone:'[name="address[phone]"]'};function l(e,n,t,r){var a,o,i,s,c,u,d,l,p,f=(a=(a=t)||"CA",r.filter(function(e){return e.code===a})[0]);o=n,i=f,Object.keys(o).forEach(function(n){o[n].labels.forEach(function(e){e.textContent=i.labels[n]})}),s=e,c=n,u=f.formatting.edit,d=c.country.wrapper,l=!1,(p=u,p.split(m).map(function(e){var n=e.match(h);return n?n.map(function(e){var n=e.replace(/[{}]/g,"");switch(n){case"zip":return"postalCode";case"province":return"zone";default:return n}}):[]})).forEach(function(n){n.forEach(function(e){c[e].wrapper.dataset.lineCount=n.length,c[e].wrapper&&("country"!==e?l?s.append(c[e].wrapper):s.insertBefore(c[e].wrapper,d):l=!0)})}),function(e,n){var t=e.zone;if(!t)return;if(0===n.zones.length)return t.wrapper.dataset.ariaHidden="true",t.input.innerHTML="";t.wrapper.dataset.ariaHidden="false";var r=t.input,a=r.cloneNode(!0);a.innerHTML="",n.zones.forEach(function(e){var n=document.createElement("option");n.value=e.code,n.textContent=e.name,a.appendChild(n)}),r.innerHTML=a.innerHTML,r.dataset.default&&(r.value=r.dataset.default)}(n,f)}return e.AddressForm=function(a,e,n){e=e||"en";var t,r,o,i,s,c=(t=a,r=function(){for(var e=Object({}),n=0;n<arguments.length;n++){var t=arguments[n];if(t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e}(d,(n=n||{inputSelectors:{}}).inputSelectors),o={},Object.keys(d).forEach(function(e){var n=t.querySelector(r[e]);o[e]=n?{wrapper:n.parentElement,input:n,labels:document.querySelectorAll('[for="'+n.id+'"]')}:{}}),o);return i=c,Object.keys(i).forEach(function(e){var n=i[e].input,t=i[e].labels;if(n){if("object"!=typeof n)throw new TypeError(i[e]+" is missing an input or select.");if("object"!=typeof t)throw new TypeError(i[e]+" is missing a label.")}}),(s=n.shippingCountriesOnly,s?fetch(location.origin+"/meta.json").then(function(e){return e.json()}).then(function(e){return-1!==e.ships_to_countries.indexOf("*")?null:e.ships_to_countries}).catch(function(){return null}):Promise.resolve(null)).then(function(r){return u(e).then(function(e){var n,t;!function(e,n,t){var r,a,o;r=t,a=n.country.input,o=a.cloneNode(!0),r.forEach(function(e){var n=document.createElement("option");n.value=e.code,n.textContent=e.name,o.appendChild(n)}),a.innerHTML=o.innerHTML,a.dataset.default&&(a.value=a.dataset.default);var i,s,c,u=n.country.input?n.country.input.value:null;i=e,c=t,(s=n).country.input.addEventListener("change",function(e){l(i,s,e.target.value,c)}),l(e,n,u,t)}(a,c,(n=e,(t=r)?n.filter(function(e){return-1!==t.indexOf(e.code)}):n))})})},e}({});

const app = {
    sliders() {
      	if($('.swiper-home').length) {
            app.homeSwiper = new Swiper('.swiper-home', {
                slidesPerView: 1,
      			lazy: true,
                pagination: {
                  el: '.swiper-pagination',
                  type: 'bullets',
                  clickable: 'true'
                },
               	effect: 'coverflow',
                coverflowEffect: {
                  rotate: 50,
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                  slideShadows: true,
                },
              	autoplay: {
                  delay: 6000,
                }
            });
        }
      
        if($('.swiper-thumbnails').length) {
            app.thumbnailsSwiper = new Swiper('.swiper-thumbnails', {
                slidesPerView: 2,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                centerInsufficientSlides: true,
                breakpoints: {
                    767: {
                        slidesPerView: 4,
                        shortSwipes: false,
                        navigation: {
                            nextEl: '.swiper-next',
                            prevEl: '.swiper-prev',
                        }
                    }
                }
            });
        }

        $(".thumb").on('click', function(){
          var slide = $(".swiper-thumbnails .swiper-slide:visible").index($(this).parent())
          app.productSwiper.slideTo(slide, 500);
        });

        if($('.swiper-sizes').length){
          app.sizesSwiper = new Swiper('.swiper-sizes', {
              slidesPerView: 2,
              margin:1,
              pagination: {
                el: '.swiper-pagination-2',
                type: 'bullets',
                clickable: 'true'
              },
              breakpoints: {
                767: {
                  slidesPerView: 3,
                  shortSwipes: false
                }
              }
          });
        }
      
        if($('.swiper-product').length) {
            app.productSwiper = new Swiper('.swiper-product', {
                slidesPerView: 1,
                navigation: {
                    nextEl: '.swiper-main-next',
                    prevEl: '.swiper-main-prev',
                },
                thumbs: {
                  swiper: app.thumbnailsSwiper
                },
                shortSwipes: false
            });
        }

        if($('.swiper-products').length) {
            app.productsSwiper = new Swiper ('.swiper-products', {
                loop: false,
                slidesPerView:1,
                observer: true,
                allowTouchMove: true,
                observeParents: true,
                autoHeight: false,
                pagination: {
                    el: '.swiper-pagination-1',
                    type: 'bullets',
                    clickable: 'true'
                },
                breakpoints: {
                    767: {
                      spaceBetween: 32,
                      allowTouchMove: true,
                      shortSwipes: true,
                      slidesPerView: 3,
                    },
                    991: {
                        slidesPerView: 4,
                    }
                },
                shortSwipes: false
            })
        }
    },

    variants: {
      init: function(){
        $('.js-variant').on('click', function(e){
          e.preventDefault();
          
          let item = $(this);
  
          const price = item.data('price'),
              variant = item.data('variant'),
              title = item.data('title'),
              image = item.data('image');

          $('[data-variant-image]').hide();
          $('.swiper-product').find('[data-variant-image="'+title+'"]').show();
          $('.swiper-thumbnails').find('[data-variant-image="'+title+'"]').show();
          app.productSwiper.update();
          app.thumbnailsSwiper.update();
  
          $('.js-variant').removeClass('item--current');
          $(this).addClass('item--current');
          
          $('.js-update-cart').hide()
          $('.js-update-cart[data-variant="'+variant+'"]').show();
  
          $('.product__prices span').html(price);
          $('.variant-name').html(', '+title);
        });
      }
    },
  
  	variantItems: {
      init: function() {
        app.variantItems.getAllProducts().then(data => {
          window.Shopify.all_products = data.all_products;
          app.variantItems.showOtherPacks();
        });
      },
      
      getAllProducts: async function() {
      	const response = await fetch("/collections/all?view=api-all-products");
        return response.json();
      },
  
      getProduct: function(handle) {
        return window.Shopify.all_products[handle]; 
      },
  
      showOtherPacks: function() {
        const all_packages = document.querySelectorAll(".pack-sizes");

        for (let product_packages of all_packages) {
          const default_package = product_packages.querySelector("input");
          const product_handle = product_packages.getAttribute("data-product");

          if (product_handle != '') {
            const product_metafields = app.variantItems.getProduct(product_handle).metafields;
            const related_products = product_metafields.related_products;
            const product_id = default_package.getAttribute("name");
            let other_sizes = "";

            related_products[0].forEach((rel_handle,key) => {
              const rel_product = app.variantItems.getProduct(rel_handle);
              if (rel_product && rel_product.metafields.pack_size) {
                let unit_suffix = "";
                if (rel_product.metafields.product_unit) { 
                  unit_suffix = ` ${rel_product.metafields.product_unit}`; 
                } else if (rel_product.title.includes("ml")) { 
                  unit_suffix = " ml"; 
                }
                const on_sale = (rel_product.variants[0].compare_at_price && rel_product.variants[0].price < rel_product.variants[0].compare_at_price) ? 'data-sale="true"' : 'data-sale="false"';
                const product_title = (rel_product.metafields.product_title) ? rel_product.metafields.product_title : rel_product.title;
                other_sizes += `<label class="pack-sizes__label"><input type="radio" name="${product_id}" value="${rel_product.variants[0].id}" data-image="${rel_product.images[0]}" ${on_sale} data-price="${formatMoney(rel_product.variants[0].price)}" data-compare-at-price="${formatMoney(rel_product.variants[0].compare_at_price)}" data-title="${product_title}" data-url="${rel_product.url}"><div class="pack-sizes__item">${rel_product.metafields.pack_size}${unit_suffix}</div></label>`
              }
            });

            product_packages.innerHTML += other_sizes;
            product_packages.style.display = 'flex';
          }
        }

        app.variantItems.initVariantHandlers();
      },
  
  	  initVariantHandlers: function() {
        const all_variants = document.querySelectorAll(".pack-sizes input");

        for (let variant of all_variants) {
          variant.addEventListener("change", function(e) {
            const product_item = e.currentTarget.closest(".product-item");
            const product = e.currentTarget;
            const product_data = product.dataset;
            
            const product_template = {
              title: product_item.querySelector("h4[role='heading']"),
              image: product_item.querySelector(".product-item__image img"),
              link: product_item.querySelector("a"),
              button: product_item.querySelector(".js-add-product"),
              price: product_item.querySelector(".full-price"),
              saved: product_item.querySelector(".product-item__saved")
            };
            
            product_template.title.innerHTML = product_data.title;
            product_template.image.setAttribute("src", product_data.image);
            product_template.link.setAttribute("href", product_data.url);
            product_template.button.setAttribute("data-variant", product.value);
            if (product_template.saved) { product_template.saved.style.display = 'none'; }
            
            const product_price = (product_data.sale == 'true') ? `<span class="old">${product_data.compare_at_price}</span><span>${product_data.price}</span>` : product_data.price;
            product_template.price.innerHTML = product_price;
          });
        }
      }
    },

    products: {
        init: function() {
            app.products.addToCart();
          	app.products.warnings();

            $('body').on('click', '.js-change-qty', function(e) {
                e.preventDefault();
                window.clearTimeout(app.products.timeout);

                let input = $(this).parents('.js-update-cart').find('input'),
                    key = $(this).parents('.js-update-cart').find('.btn').attr('data-key'),
                    type = $(this).attr('data-type'),
                    btn = $(this).parents('.js-update-cart').find('.btn'),
                    quantity = parseFloat(input.val());

                if(type == 'plus') {
                  quantity++;
                } else {
                  quantity--;
                }
              
				input.val(quantity);
              
                app.products.timeout =  window.setTimeout(function(){
                    btn.parents('.product__details').addClass('loading');
                    btn.parents('.product-item').addClass('loading');
                    Shopify.theme.cart.updateItem(key, { quantity }).then(state => {
                        if(quantity == 0) {
                            var translation = ' ' + btn.data('add');
                            btn.parent().removeClass('edit');
                            if(!btn.parents('.shopify-product-form').length) {
                               btn.removeClass('btn--border'); 
                           }
                            btn.find('span').text(translation);
                            btn.attr('data-added', 'false');
                        } else {
                            var translation = ' ' + btn.data('incart');
                            input.val(quantity);
                            btn.find('span').text(quantity + translation);
                        }
                        btn.parents('.product__details').removeClass('loading');
                        btn.parents('.product-item').removeClass('loading');
    
                        $('.total-qty').show().html(state.item_count);
    
                        if($('body').hasClass('template-cart')){
                            app.products.updateCart();
                        }
                    });
                },500);
            });
        },

        updateCart: function() {
            Shopify.theme.cart.getState().then(state => {
              if(state.item_count > 0) {
                $('.js-line-items').html('');
                for (var i in state.items) {
                  var item = state.items[i];
                  var source = document.getElementById("line-template").innerHTML;
                  var template = Handlebars.compile(source);
                  var context = {
                    title: item.product_title,
                    link: item.url,
                    original_price: '£'+formatMoney(item.original_price, '{{amount}}'),
                    price: '£'+formatMoney(item.final_price, '{{amount}}'),
                    total: '£'+formatMoney(item.final_line_price, '{{amount}}'),
                    image: getSizedImageUrl(item.image, '160x160'),
                    key: item.key,
                    quantity: item.quantity,
                    discounts: item.discounts,
                    isDiscount: item.original_line_price > item.final_line_price,
                    line: i + 1
                  };

                  $('.js-line-items').append(template(context));
                  $('.loader').fadeOut();
                  $('.cart').removeClass('loading');
                }
                $('.js-free-delivery').attr('data-total',state.total_price)
                $('.value--total').html('£'+formatMoney(state.total_price, '{{amount}}'));
                $('.total-qty').show().html(state.item_count);
                $('.total-qty').show().html(state.item_count);
                if(state.total_discount > 0) {
                    if(!$('.value--discount').length) {
                        var source = document.getElementById("discount-template").innerHTML;
                        var template = Handlebars.compile(source);
                        var context = {
                            price: '£'+formatMoney(state.total_discount, '{{amount}}')
                        };
                        $(template(context)).insertAfter('.cart__total__row');
                    } else {
                        $('.value--discount').text('£'+formatMoney(state.total_discount, '{{amount}}'))
                    }
                } else {
                    $('.value--discount').parent('.cart__total__row').remove();
                }
              } else {
                location.reload();
              }
            });
        },

        addToCart() {
            $('body').on('click', '.js-add-product', function(e) {
                e.preventDefault();
                const btn = $(this),
                	  variantID = Number(btn.attr('data-variant'));
                btn.closest('.product__details').find('.product__details').addClass('loading');
                btn.closest('.product-item').addClass('loading');

                if (btn.attr('data-added') == 'true') {
                    window.top.location.href = '/cart';
                } else {
                    Shopify.theme.cart.addItem(variantID, 1).then(item => {
                        const translation = ' ' + btn.data('incart');

                        btn.parent().find("input[name='quantity']").val(item.quantity)
                        btn.parent().addClass('edit');
                        btn.parents('.product__details').find('.product__details').removeClass('loading');
                        btn.parents('.product-item').removeClass('loading');
                        btn.addClass('btn--border');
                        btn.attr('data-added', 'true');
                        btn.find('span').text(item.quantity + translation);
                        btn.attr('data-key',item.key);

                        $('.total-qty').show().html(parseFloat($('.total-qty').html()) + 1);

                        if($('body').hasClass('template-cart')){
                            app.products.updateCart();
                        }
                    });
                }
            });
        },
      
        warnings: function() {
			let header = $( "h3:contains('Warnings')" ),
                content = header.nextAll();
            
          	content.wrapAll('<div class="toggle-content"></div>');
          	
          	let toggleContent = $('.toggle-content').hide().after('<div class="toggle-trigger"><span>Show details</span><span>Hide details</span></div>'),
                trigger = $('.toggle-trigger');
          
            trigger.on('click', function(e){
              	trigger.toggleClass('active');
				toggleContent.slideToggle(400);
            });
        }
    },

    cart: {
        init: function() {
            var _this = this;
        
            $('.cart').on('click', '.js-change-quantity', function(e){
                e.preventDefault();
                window.clearTimeout(app.products.timeout);
                let input = $(this).parent().find('input'),
                    row = $(this).parents('tr'),
                    key = $(this).parent().attr('data-key'),
                    type = $(this).attr('data-type'),
                    quantity = parseFloat(input.val());
        
                if(type == 'plus') {
                  quantity++;
                } else {
                  quantity--;
                }
                
                input.val(quantity);
                app.products.timeout = window.setTimeout(function(){
                  $('.loader').fadeIn();
                  input.prop('disabled', true);
                  app.cart.updateItems(key,quantity);
                },500);
            });
        
            $('.cart').on('blur', '.quantity input', function(e){
                e.preventDefault();
                $('.loader').fadeIn();
                $('.cart').addClass('loading');
                let input = $(this),
                    row = $(this).parents('tr'),
                    key = $(this).parent().attr('data-key'),
                    type = $(this).attr('data-type'),
                    quantity = Math.round(Math.abs(parseFloat(input.val())));
        
                input.prop('disabled', true);
        
                app.cart.updateItems(key,quantity);
            });
        
            $('.cart').on('click', '.cart__table__remove', function(e){
                e.preventDefault();
                $('.loader').fadeIn();
                $('.cart').addClass('loading');
                let key = $(this).attr('data-key');
        
                Shopify.theme.cart.removeItem(key).then(state => {
                  if(state.item_count > 0) {
                    $('.js-line-items').html('');
                    for (var i in state.items) {
                      var item = state.items[i];
                      var source = document.getElementById("line-template").innerHTML;
                      var template = Handlebars.compile(source);
                      var context = {
                        title: item.product_title,
                          link: item.url,
                          original_price: '£'+formatMoney(item.original_price, '{{amount}}'),
                          price: '£'+formatMoney(item.final_price, '{{amount}}'),
                          total: '£'+formatMoney(item.final_line_price, '{{amount}}'),
                          image: getSizedImageUrl(item.image, '160x160'),
                          key: item.key,
                          quantity: item.quantity,
                          discounts: item.discounts,
                          isDiscount: item.original_line_price > item.final_line_price,
                          line: i + 1
                      };
        
                      $('.js-line-items').append(template(context));
                      $('.loader').fadeOut();
                      $('.cart').removeClass('loading');
                    }
                    $('.value--total').html('£'+formatMoney(state.total_price, '{{amount}}'));
                    $('.total-qty').show().html(state.item_count);

                    $('.total-qty').show().html(state.item_count);
                    if(state.total_discount > 0) {
                      if(!$('.value--discount').length) {
                        var source = document.getElementById("discount-template").innerHTML;
                        var template = Handlebars.compile(source);
                        var context = {
                            price: '£'+formatMoney(state.total_discount, '{{amount}}')
                        };
                        $(template(context)).insertAfter('.cart__total__row');
                      } else {
                        $('.value--discount').text('£'+formatMoney(state.total_discount, '{{amount}}'))
                      }
                    } else {
                      $('.value--discount').parent('.cart__total__row').remove();
                    }
                  } else {
                    location.reload();
                  }
                });
        
            });
        },
        
        updateItems: function(key,quantity) {
            Shopify.theme.cart.updateItem(key, { quantity }).then(state => {
              if(state.item_count > 0) {
                $('.js-line-items').html('');
                for (var i in state.items) {
                  var item = state.items[i];
                  var source = document.getElementById("line-template").innerHTML;
                  var template = Handlebars.compile(source);
                  var context = {
                    title: item.product_title,
                    link: item.url,
                    original_price: '£'+formatMoney(item.original_price, '{{amount}}'),
                    price: '£'+formatMoney(item.final_price, '{{amount}}'),
                    total: '£'+formatMoney(item.final_line_price, '{{amount}}'),
                    image: getSizedImageUrl(item.image, '160x160'),
                    key: item.key,
                    discounts: item.discounts,
                    isDiscount: item.original_line_price > item.final_line_price,
                    quantity: item.quantity,
                    line: i + 1
                  };
        
                  $('.js-line-items').append(template(context));
                  $('.loader').fadeOut();
                  $('.cart').removeClass('loading');
                }
                $('.js-free-delivery').attr('data-total',state.total_price)
                $('.value--total').html('£'+formatMoney(state.total_price, '{{amount}}'));
                $('.total-qty').show().html(state.item_count);
                $('.total-qty').show().html(state.item_count);
        
                if(state.total_discount > 0) {
                  if(!$('.value--discount').length) {
                    var source = document.getElementById("discount-template").innerHTML;
                    var template = Handlebars.compile(source);
                    var context = {
                        price: '£'+formatMoney(state.total_discount, '{{amount}}')
                    };
                    $(template(context)).insertAfter('.cart__total__row');
                  } else {
                    $('.value--discount').text('£'+formatMoney(state.total_discount, '{{amount}}'))
                  }
                } else {
                  $('.value--discount').parent('.cart__total__row').remove();
                }
              } else {
                location.reload();
              }
            });
        },
    },

    recommendations: function() {
        const $container = $('.product-recommendations'),
              baseUrl = $container.data('baseUrl'),
              productId = $container.data('productId'),
              limit = $container.data('limit'),
              productRecommendationsUrlAndContainerClass = baseUrl + '?section_id=product-related&limit=' + limit + '&product_id=' +productId + ' .product-recommendations';
        
      	$container.parent().load(productRecommendationsUrlAndContainerClass, function() {
            app.lazyload();
            app.sliders();
        });
    },

    lazyload: function() {
        let lazyImages = [].slice.call(document.querySelectorAll(".lazyloading-bc")),
        	  lazyImages2 = [].slice.call(document.querySelectorAll(".lazyloading"));
      
        lazyImages = lazyImages.concat(lazyImages2);
            const ua = navigator.userAgent.toLowerCase();
             
            if (("IntersectionObserver" in window ) || (ua.indexOf('safari') == -1)) {
                let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;
                        if(lazyImage.classList.contains('lazyloading-bc')){
                            lazyImage.style.backgroundImage = 'url("'+lazyImage.dataset.src+'")';
                            lazyImage.classList.remove("lazyloading-bc");
                            lazyImageObserver.unobserve(lazyImage);
                        } else {
                            lazyImage.src = lazyImage.dataset.src;
                            lazyImage.classList.remove("lazyloading");
                            lazyImageObserver.unobserve(lazyImage);
                        }
                    }
                });
            });
      
            lazyImages.forEach(function(lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        }
    },

    account: function() {
      const selectors = {
        recoverPasswordFormTriggers: '[data-recover-toggle]',
        recoverPasswordForm: '[data-recover-form]',
        loginForm: '[data-login-form]',
        formState: '[data-form-state]',
        resetSuccess: '[data-reset-success]',
        details: '[data-details]',
        orders: '[data-orders]',
        orders_trigger: '[data-orders-trigger]'
      };
      
      function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      }
      
      function checkUrlHash() {
        const hash = window.location.hash;
      
        if (hash === '#recover') {
          toggleRecoverPasswordForm();
        }
      }
      
      /**
       *  Show/Hide recover password form
       */
      function toggleRecoverPasswordForm() {
        document.querySelector(selectors.recoverPasswordForm).classList.toggle('hide');
        document.querySelector(selectors.loginForm).classList.toggle('hide');
      }
      
      /**
       *  Show reset password success message
       */
      function resetPasswordSuccess() {
        if (document.querySelector(selectors.formState)) {
          document.querySelector(selectors.resetSuccess).classList.remove('hide');
        }
      }
      
      if (document.querySelector(selectors.recoverPasswordForm)) {
        checkUrlHash();
        resetPasswordSuccess();
      
        document.querySelectorAll(selectors.recoverPasswordFormTriggers).forEach((trigger) => {
          trigger.addEventListener('click', onShowHidePasswordForm);
        });
      }

   
      const hideClass = 'hide';
      
      function checkUrlHash() {
        const hash = window.location.hash;
        if (hash === '#orders') {
          toggleOrders();
        }
      }
      
      function toggleOrders() {
        document.querySelector(selectors.details).classList.toggle('hide');
        document.querySelector(selectors.orders).classList.toggle('hide');
      }
      
      $(selectors.orders_trigger).on('click', function(){
        toggleOrders();
      });
      
      checkUrlHash();
    },

    addresses: function() {
      const selectors = {
        addressContainer: '[data-address]',
        addressFields: '[data-address-fields]',
        addressToggle: '[data-address-toggle]',
        addressForm: '[data-address-form]',
        addressDeleteForm: '[data-address-delete-form]',
      };
      const hideClass = 'hide';

      function initializeAddressForm(container) {
        var addressFields = container.querySelector(selectors.addressFields);
        var addressForm = container.querySelector(selectors.addressForm);
        var deleteForm = container.querySelector(selectors.addressDeleteForm);

        container.querySelectorAll(selectors.addressToggle).forEach((button) => {
          button.addEventListener('click', () => {
            addressForm.classList.toggle(hideClass);
          });
        });

        Shopify.theme.addresses.AddressForm(addressFields, 'en');

        $(selectors.addressDeleteForm).find('.link--confirm').on('click', function(e){
          $(selectors.addressDeleteForm).find('.js-confirm').slideDown(300);
        });
        $(selectors.addressDeleteForm).find('.link--no').on('click', function(e){
          $(selectors.addressDeleteForm).find('.js-confirm').slideUp(300);
        });
      }

      var addressForms = document.querySelectorAll(selectors.addressContainer);

      if (addressForms.length) {
        addressForms.forEach((addressContainer) => {
          initializeAddressForm(addressContainer);
        });
      }
    },

    form: {
      init: function() {
          const invalidClassName = 'invalid',
                inputs = document.querySelectorAll('input, select, textarea');
                                                   
          inputs.forEach(function (input) {
              input.addEventListener('invalid', function () {
                  input.classList.add(invalidClassName)
              })

              input.addEventListener('input', function () {
                  if (input.validity.valid) {
                    input.classList.remove(invalidClassName)
                  }
              })
          });
      }
    },

    tracking: function(){
        if($('.form_tracking_submit').length) {
        	const tracking_number = document.getElementsByClassName('field_number')[0].value,
                  is_numeric = /^\d+$/.test(tracking_number),
                  royal_mail = /([A-Z]{2})([0-9]*)GB+/.test(tracking_number);

            $('.form_tracking_submit').on('click',function(e){  
              e.preventDefault();

              if (tracking_number.length == 14 && is_numeric ){
                window.open('https://www.dpd.co.uk/apps/tracking/?reference='+tracking_number, "_blank", "noopener noreferrer");
              } else if (tracking_number.length == 10 && is_numeric){
                window.open('https://www.dhl.co.uk/en/express/tracking.html?AWB='+tracking_number, "_blank", "noopener noreferrer")
              } else if (royal_mail){
                window.open('https://www.royalmail.com/track-your-item?trackNumber='+tracking_number, "_blank", "noopener noreferrer")
              } else {
                const node = document.createElement('span');
                const textNode = document.createTextNode('This tracking number cannot be found');
                node.appendChild(textNode);
                document.getElementsByClassName('field_number_error')[0].appendChild(node)
              }

              setTimeout(function(){
                $('.field_number_error span').remove();
              },2000);
            });
		}
    },
      
      qmb: {
        init: function() {
          var qmb = $(".js-custom-qmb");

          if (qmb.length > 0) {
            var delay = $('.js-custom-qmb').data('delay');
            var productsSwiper = new Swiper ('.js-custom-qmb', {
              loop: true,
              direction: 'vertical',
              slidesPerView: 1,
              spaceBetween: 0,
              effect:'coverflow',
              speed: 400,
              autoplay: {
                delay: delay == '' ? '5000' : delay
              }
            });

            app.qmb.slider = productsSwiper;
          }
        }
      },

        nextDayDelivery: {
          init: function() {
            const ndDelivery = $(".nd-delivery");

            if (ndDelivery.length > 0 && ndDelivery.attr('data-enabled') == '1') {
              const ndCounter = ndDelivery.find('.nd-delivery__counter');
              const ndCounterTime = ndDelivery.attr('data-time').split(":");
              let ndTime = {
                current: luxon.DateTime.local().setZone('Europe/London'),
                today: luxon.DateTime.local().setZone('Europe/London').set({ hour: ndCounterTime[0], minute: ndCounterTime[1] }),
                tomorrow: luxon.DateTime.local().setZone('Europe/London').plus({ days: 1 }).set({ hour: ndCounterTime[0], minute: ndCounterTime[1] }),
              };
              const ndDay = (ndTime.current.c.hour < ndCounterTime[0] || (ndTime.current.c.hour == ndCounterTime[0] && ndTime.current.c.minute < ndCounterTime[1])) ? ndTime.today : ndTime.tomorrow; 

              const countInterval = window.setInterval(function() { 
                const ndDifference = ndDay.diffNow(['hours','minutes','seconds']);
                const { days, hours, minutes, seconds } = ndDifference.values;
                if (seconds >= 0) { 
                  let counterDiff = '';
                  counterDiff += (days > 0) ? (`${days} day` + (days > 1 ? 's ' : ' ')) : '';
                  counterDiff += (days > 0 || hours > 0) ? (`${hours} hour` + (hours > 1 ? 's ' : ' ')) : '';
                  counterDiff += (hours > 0 || minutes > 0) ? (`${minutes} minute` + (minutes > 1 ? 's ' : ' ')) : '';
                  counterDiff += `${seconds.toFixed(0)} second` + (seconds.toFixed(0) > 1 ? 's' : '');

                  ndCounter.html(counterDiff);
                } else {
                  ndCounter.html('');
                  (countInterval != null) && window.clearInterval(countInterval);
                }
              }, 1000);
            } else {
              app.nextDayDelivery.hide.qmb();
              app.nextDayDelivery.hide.pdp();
              app.nextDayDelivery.hide.plp();
              app.nextDayDelivery.hide.cart();
            }
          },
          hide: {
            qmb: function() {
              if (app.qmb.slider) {
                const ndDeliverySwiper = $(".custom-qmb .swiper-wrapper");
                const ndDeliverySlide = $(".swiper-slide--nd-delivery");
                const ndDeliverySID = [];
                ndDeliverySlide.each(function(index) {
                  const sid = $(ndDeliverySlide[index]).attr('data-swiper-slide-index');
                  ndDeliverySID.push(sid); 
                });
                app.qmb.slider.removeSlide(ndDeliverySID);
                
                if (ndDeliverySwiper.find("div").length == 0) {
                  $(".custom-qmb").remove();
                }
              }
            },
            pdp: function() {
              $('.nd-delivery--product-page').remove();
            },
            plp: function() {
              $('.nd-delivery--collection').remove();
            },
            cart: function() {
              $('.nd-delivery--cart').remove();
            }
          }
        },

    init: function() {
        app.recommendations();
        app.sliders();
        app.lazyload();
        app.products.init();
      	app.variantItems.init();
        app.cart.init();
        app.variants.init();
        app.account();
        app.addresses();
        app.form.init();
        app.tracking();
      	app.qmb.init();
      	app.nextDayDelivery.init();
    }
}
        
$(function() {
    app.init();

    $(window).on("resize orientationchange", function(){
        if($('swiper-product').length){app.productSwiper.destroy()}
        if($('swiper-thumbnails').length){app.thumbnailsSwiper.destroy()}
        if($('swiper-products').length){app.productsSwiper.destroy()}
        app.sliders();
    });
});

const moneyFormat = '£{{amount}}';

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }
  
    if (size === 'master') {
      return removeProtocol(src);
    }
  
    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];
  
      return removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return null;
    }
}
  
function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
}


document.querySelector(".desktop-search .site-header__icon").addEventListener("click", function(){
  document.querySelector(".search-bar").classList.add("open");
  document.querySelector("html body").classList.add("modal-open");
});
document.querySelector(".search-bar__close").addEventListener("click", function(){
  document.querySelector(".search-bar").classList.remove("open");
  document.querySelector("html body").classList.remove("modal-open");
});
document.querySelector(".mobile-nav .site-header__icon").addEventListener("click", function(){
  document.querySelector(".search-bar").classList.add("open");
  document.querySelector("html body").classList.add("modal-open");
});
document.querySelector(".page_backdrop").addEventListener("click", function(){
  document.querySelector(".search-bar").classList.remove("open");
  document.querySelector("html body").classList.remove("modal-open");
  document.querySelector("#shopify-section-header .modal").style.display = "none";
});

$(".site-header__search-toggle").keydown(function(e) {
  if (e.keyCode == 13) {
    
    setTimeout(function() { 
      document.querySelector("#Search").setAttribute('tabindex', '0');
      document.querySelector("#Search").focus();
    }, 500);
    
    const serachElements = '#SearchDrawer #Search, #SearchDrawer button';
    const searchSelectors = document.querySelector('#SearchDrawer');
    const firstSearchElement = searchSelectors.querySelectorAll(serachElements)[0];
    const searchContent = searchSelectors.querySelectorAll(serachElements);
    const lastSearchElement = searchContent[searchContent.length - 1];

    document.addEventListener('keydown', function(e) {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        if (document.activeElement === firstSearchElement) {
          lastSearchElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastSearchElement) {
          firstSearchElement.focus();
          e.preventDefault();
        }
      }
    });
    firstSearchElement.focus();
    
  }
});

$("#SearchDrawer button").keydown(function(e) {
  if (e.keyCode == 13) {
    $("#SearchDrawer").removeClass(open);
    setTimeout(function() {
    $(".desktop-search .site-header__search-toggle").focus();
    }, 500);
  }
});
